
import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

// Sample data - in a real app, this would come from an API
const activityData = {
  '7days': [
    { name: 'Mon', consultations: 4, sessions: 3, followups: 1 },
    { name: 'Tue', consultations: 3, sessions: 2, followups: 2 },
    { name: 'Wed', consultations: 5, sessions: 4, followups: 0 },
    { name: 'Thu', consultations: 2, sessions: 3, followups: 1 },
    { name: 'Fri', consultations: 3, sessions: 2, followups: 2 },
    { name: 'Sat', consultations: 1, sessions: 1, followups: 0 },
    { name: 'Sun', consultations: 0, sessions: 0, followups: 0 }
  ],
  '30days': [
    { name: 'Week 1', consultations: 12, sessions: 8, followups: 4 },
    { name: 'Week 2', consultations: 10, sessions: 7, followups: 5 },
    { name: 'Week 3', consultations: 8, sessions: 6, followups: 3 },
    { name: 'Week 4', consultations: 11, sessions: 9, followups: 6 }
  ]
};

const ActivityChart: React.FC = () => {
  const [timeRange, setTimeRange] = useState<'7days' | '30days'>('7days');
  
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-lg">Activity Overview</CardTitle>
        <Select value={timeRange} onValueChange={(value: '7days' | '30days') => setTimeRange(value)}>
          <SelectTrigger className="w-[140px] h-8">
            <SelectValue placeholder="Select period" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="7days">Last 7 days</SelectItem>
            <SelectItem value="30days">Last 30 days</SelectItem>
          </SelectContent>
        </Select>
      </CardHeader>
      <CardContent>
        <div className="h-[200px] w-full mt-2">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={activityData[timeRange]} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" />
              <YAxis axisLine={false} tickLine={false} />
              <Tooltip 
                formatter={(value) => [`${value}`, '']}
                labelFormatter={(label) => `${label}`}
                contentStyle={{ borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
              />
              <Bar name="Consultations" dataKey="consultations" fill="#8884d8" radius={[4, 4, 0, 0]} />
              <Bar name="Sessions" dataKey="sessions" fill="#82ca9d" radius={[4, 4, 0, 0]} />
              <Bar name="Follow-ups" dataKey="followups" fill="#ffc658" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivityChart;
